const messagesEn = {
  about: 'About',
  acceptanceCriteria: 'Acceptance Criteria',
  accomplishments: 'Accomplishments',
  actions: 'Actions',
  activity: 'Activity',
  activatePod: 'Activate POD',
  activePods: 'Active Pods',
  add: 'Add',
  addBlocker: 'Add Blocker Information',
  addingCandidateWait: 'Adding Candidate Wait...',
  addPortfolio: 'Add Portfolio',
  addStakeholder: 'Add Stakeholder',
  addVideoUpdate: 'Add Video Update',
  findAgents:"Find Agent",
  all: 'All',
  allReporters: 'All Reporters',
  allRepoCheckins: 'All Repo Checkins',
  approve: 'Approve',
  approved: 'Approved',
  approvalRequests: 'Approval Requests',
  approvedPRCount: 'Approved PR Count',
  assignedItems: 'Assigned Items',
  availability: 'Availability',
  availableDate: 'Available date',
  backToPods: 'Back to My Pods',
  basicInformation: 'Basic Information',
  blocker: 'Blocker',
  blockerDetails: 'Blocker Details',
  blockers: 'Blockers',
  board: 'Board',
  browseTalent: 'Browse Talent',
  bugs: 'Bugs',
  calendlyUrl: 'Calendly URL',
  cancel: 'Cancel',
  candidates: 'Candidates',
  categories: 'Categories',
  certifications: 'Certifications',
  certificationUrl: 'Certification Url',
  checkBoxBlocker: 'Check this box if it is a blocker',
  ciCdPipeline: 'CICD Pipeline',
  clear: 'Clear',
  client: 'Client',
  clickHereUploadVideoClip: 'Click here to Upload a Video Clip !',
  cloudCost: 'Cloud Cost',
  code: 'Lines of Code',
  codeSmells: 'Code Smells',
  commentHere: 'comment here...',
  category:"Category",
comments:"Comments",



  companyName: 'Company Name',
  copied: 'Copied!',
  copyright: 'Copyright © 2025-present Brilli Global, Inc. All rights reserved.',
  copyToClipboard: 'Copy to clipboard',
  cost: 'Cost',
  costDetails: 'Cost Details',
  country: 'Country',
  create: 'Create',
  createArt: 'Create ART',
  createGig: 'Create Solution',
  createPod: 'Create POD',
  createProfile: 'Create Profile',
  createProfileOpportunity: 'Create your profile in our talent database to be included for various remote work opportunities.',
  createTask: 'Create Task',
  createYourOwnPod: 'Create your own POD and browse for projects',
  creatingProfile: 'Creating profile',
  currency: 'Currency',
  currentlyAvailable: 'Currently Available',
  currentWeek: 'Current Week',
  dashboard: 'Dashboard',
  date: 'Date',
  dateRangeFilter: 'Date Range Filter',
  deactivatePod: 'Deactivate POD',
  deactivateToUpdate: 'De-activate The POD to Update the POD!',
  defects: 'Defects',
  delete: 'Delete',
  deletePod: 'Delete POD',
  description: 'Description',
  detailsForGitHubRepo: 'Details for GitHub Repository',
  done: 'close',
  Done: 'DONE',
  doraMetrics: 'Dora Metrics',
  dueDate: 'Due Date',
  duplicatedLinesDensity: 'Duplicated Lines Density',
  edit: 'Edit',
  education: 'Education',
  educationAndCertifications: 'Education & Certifications',
  email: 'E-Mail',
  podTime: "POD Time",  
  createHub:	"Create Hub",
  createSolution:"Create Solution",
  podVelocity: "POD Velocity",
    podBlockers: "POD Blockers",
    podsync:"POD Sync",
  endDate: 'End date',
  enterEmailToInvite: 'Enter an E-Mail to Invite',
  enterPodMission: 'Enter POD Mission',
  enterPodName: 'Enter POD Name',
  enterStoryDescription: 'Enter a Story Description',
  executionDate: 'Execution Date',
  executionID: 'Execution ID',
  externalPod: 'External POD',
  fileNameNoSpaces: 'The file name should not include spaces between all elements or characters',
  fileUpload: 'File Upload',
  findBestFreelancers: 'Find the best freelancers or talent pods to get your projects delivered at a faster pace!',
  findBestPod: 'Find PODs that match your experience/skillset',
  findPods: 'Find Pods',
  findTalent: 'Find Talent',
  findYourBestTalentPod: 'Find your best talent POD',
  firstName: 'First Name',
  focus: 'Focus',
  gitHubRepo: 'GitHub Repo',
  gitHubUsername: 'GitHub Username',
  github: 'Github',
  githubSummary: 'GitHub Summary',
  githubUrl: 'Github URL',
  githubUser: 'GitHub User',
  giveRating: 'Give Rating',
  globalWorkPlatform: 'Global Work platform',
  home: 'Home',
  hoursPerWeek: 'Hours per Week',
  inactivePod: 'Inactive POD',
  individual: 'Individual',
  industry: 'Industry',
  inProgress: 'IN PROGRESS',
  institute: 'Institute',
  internalPod: 'Internal POD',
  invite: 'Invite',
  invoices: 'Invoices',
  issueKey: 'Issue Key',
  issueStatus: 'Issue Status',
  issueSummary: 'Issue Summary',
  jiraIssue: 'Jira Issue',
  jiraIssues: 'Jira Issues',
  jiraItem: 'Jira Item',
  jiraTimeDetails: 'Time Log',
  jiraUsername: 'Jira Username',
  keepDoing: 'Keep Doing',
  keyword: 'Keyword',
  languageSpoken: 'Language Spoken',
  lastName: 'Last Name',
  latestSprintVelocity: 'Latest Sprint Velocity',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'LinkedIn URL',
  linesOfCodeByDay: 'Lines of Code By day',
  listOfTalents: 'List of Talents',
  loading: 'Loading',
  loadingAcceptanceCriteria: 'Loading Acceptance Criteria',
  loadingStoryDescription: 'Loading Story Description',
  loadingTestCases: 'Loading Test Cases',
  logOut: 'Log Out',
  login: 'Login',
  manage: 'Manage',
  manageActivities: 'Manage your Daily POD activities and Updates',
  manageProfile: 'Manage profile',
  manageProfileHere: 'Manage your profile here',
  managePod: 'Manage POD',
  managePods: 'Manage all your pods and their activities',
  markComplete: 'Mark Complete',
  middleName: 'Middle Name',
  myPods: 'My Pods',
  myTasks: 'My Tasks',
  name: 'Name',
  ncloc: 'Ncloc',
  newActivityUpdate: 'New Activity Update',
  next: 'Next',
  noArtOptionsAvailable: 'No ART Options Available',
  noBlockers: 'There Are No blockers',
  noCandidates: 'No Candidates are Added',
  noCandidatesAddedToPod: 'No Candidates Added to POD!',
  noCandidateReviews: 'There are no candidate reviews.',
  noData: 'No Data',
  noDataAvailable: 'No data available',
  noExperience: 'No Experience',
  noMatchingPods: 'There are no matching pods available',
  noNotifications: 'There are no notifications',
  noPodActivity: 'You Don\'t Have Any POD Activity',
  noPods: 'You Don\'t have any POD',
  noPodTasks: 'You don\'t have any POD Tasks',
  noReviews: 'There are no reviews.',
  noStakeholders: 'There Are No stakeholders for this POD',
  noSubscription: 'You don\'t have any subscription plan',
  noVideoAvailable: 'No video available',
  notifications: 'Notification Recipient',
  otherInformation: 'Other Information',
  pending: 'Pending',
  pendingPods: 'Pending Pods',
  phoneNumber: 'Phone Number',
  pipelineExecutionDetails: 'Pipeline Execution Details',
  pipelineName: 'Pipeline Name',
  pipelineVersion: 'Pipeline Version',
  pleaseEnterStoryDescription: 'Please enter a story description and click on submit',
  POD: 'POD',
  podActivities: 'POD Activities',
  podActivity: 'POD Activity',
  podAnalytics: 'POD Analytics',
  podAssist: 'POD Assist',
  podAutomation: 'POD Automation',
  podBoard: 'POD Board',
  podCategories: 'POD Categories',
  podDescription: 'POD Description',
  podExperience: 'POD Experience',
  podFeedback: 'POD Feedback',
  podMetrics: 'POD Metrics',
  partnerMetrics: 'Partner Metrics',
  podName: 'POD Name',
  podQuery: 'POD Query',
  podRequests: 'POD REQUESTS',
  podRetro: 'POD Retro',
  podSize: 'POD Size',
  podTasks: 'POD Tasks',
  podTaskDescription: 'POD Task Description',
  podTaskDueDate: 'POD Task Due Date',
  podTaskName: 'POD Task Name',
  podTaskOwner: 'POD Task Owner',
  podTaskStatus: 'POD Task Status',
  podTechStack: 'POD Tech Stack',
  podTeamMember: 'POD Team Member',
  podType: 'POD Type',
  portfolio: 'Portfolio',
  portfolioUrl: 'Portfolio URL',
  post: 'Post',
  postActivity: 'Post Activity',
  postPodActivity: 'Post POD Activity',
  postRequirement: 'Post Requirement',
  posting: 'Posting...',
  postedDate: 'Posted Date',
  postedRequirements: 'Your Posted POD Requirements',
  positionName: 'Position Name',
  prCount: 'PR Count',
  preferredWorkHours: 'Preferred Work Hours',
  prev: 'Prev',
  previousPods: 'Previous Pods',
  previousWeek: 'Previous Week',
  primarySkill: 'Primary Skill',
  privacyPolicy: 'Privacy Policy',
  privatePods: 'Private Pods',
  prSummary: 'PR Summary',
  projectKey: 'Project Key',
  profileLink: 'Profile Link',
  profileVisibility: 'Profile Visibility',
  public: 'Public',
  qualification: 'Qualification',
  ratePerHour: 'Rate /hr',
  ratePerMonth: 'Rate /month',
  recentSearches: 'Recent Searches',
  region: 'Region',
  register: 'Register',
  resetPassword: 'Reset Password',
  restricted: 'Restricted',
  retro: 'Retro',
  review: 'Review & Rating',
  revisionSummary: 'Revision Summary',
  revisionURL: 'Revision URL',
  resume: 'Resume',
  resumeLink: 'View Resume',
  rowsPerPage: 'Rows per page',
  save: 'Save',
  search: 'Search',
  searchProjects: 'Search for projects',
  secondarySkill: 'Secondary Skill',
  select: 'Select',
  selectArtName: 'Select ART Name',
  selectAUser: 'Select a User',
  selectFilter: 'Select Filter',
  applyFilters:"Apply Filters",
  selectItemsPerPage: 'Select items per page',
  selectJiraIssues: 'Select Jira Issues',
  selectPod: 'Select a POD',
  selectPodTeamMember: 'Select POD Team Member',
  selectPods: 'Select Pods',
  services: 'Services',
  setting: 'Setting',
  shareableLink: 'Shareable Link',
  signUpToGetStarted: '"Sign up" below to Get Started!',
  getStarted:"Get Started",
  skills: 'Skills',
  skillsAndExpertise: 'Skills & Expertise',
  sonarqubeprojectkey: 'Sonarqube Project Key',
  sonarqubeStats: 'Sonarqube Stats',
  specialization: 'Specialization',
  sprintVelocity: 'Sprint Velocity',
  sprint: 'Sprint',
  spotsLeft: 'Spots Left',
  startDate: 'Start date',
  startDoing: 'Start Doing',
  status: 'Status',
  stopDoing: 'Stop Doing',
  storyDescription: 'Story Description',
  stories: 'Stories',
  submit: 'Submit',
  submittedDate: 'Submitted Date',
  submittedPRCount: 'Submitted PR Count',
  subscription: 'Subscription',
  talentApprovalRequests: 'Talent Approval Requests',
  talentCode: 'Talent Code',
  taskForm: 'Task Form',
  taskManager: 'Task Manager',
  taskName: 'Task Name',
  tasks: 'Tasks',
  teamMember: 'Team Member',
  techStack: 'TechStack',
  termsOfService: 'Terms of Service',
  testCases: 'Test Cases',
  time: 'Time',
  timeLog: 'Time Log',
  timeSubmit: 'Time Submit',
  timeZone: 'Time Zone',
  toDo: 'TO DO',
  todaysFocus: "Today's Focus",
  totalLinesChangedLastWeek: 'Total Lines Changed Last Week',
  totalLinesChangedThisWeek: 'Total Lines Changed This Week',
  totalPRCount: 'Total PR Count',
  university: 'University',
  update: 'Update',
  updateProfileHere: 'Update your profile here',
  updatingVisibility: 'Updating visibility...',
  upload: 'Upload',
  userStory: 'User Story',
  validFrom: 'Valid from',
  validTill: 'Valid till',
 talentexplorer: "Talent Explorer",
 interviewrequests:"Interview Requests",
  videoUrl: 'Video Url',
  view: 'View',
  viewActivities: 'View Activities',
  viewDetails: 'View Details',
  viewPodActivities: 'View POD Activities',
  viewPodDetails: 'View POD Details',
  viewProfile: 'View Profile',
  viewTasks: 'View Tasks',
  viewTimeEntries: 'View Time Entries',
  viewVideo: 'View Video',
  visitFindTalent: "Please visit the 'Find Talent' page and add talented individuals to your POD.",
  vulnerabilities: 'Vulnerabilities',
  welcome: 'Welcome to Artemy.ai!',
  workExperience: 'Work Experience',
  yourPod: 'Your POD',
  yourPods: 'Your Pods',
  yourPostedPodActivity: 'Your Posted POD Activity',
 
  findTickets: 'Find Tickets',
  epics: 'Epics',
  podTasks: 'Pod Tasks',
  date: 'Date',
  talent: 'Talent',
  focus: 'Focus',
  startDate: 'Start Date',
  endDate: 'End Date',
  status: 'Status',
  allStatus: 'All Status',
  blocked: 'Blocked',
  onTrack: 'On Track',
  activityDetails: 'Activity Details',
  jiraIssues: 'Jira Issues',
  todaysFocus: "Today's Focus",
  accomplishments: 'Accomplishments',
  blockers: 'Blockers',
  videoUpdate: 'Video Update',
  comments: 'Comments',
  addBlockerInformation: 'Add Blocker Information',
  blockerDetails: 'Blocker Details',
  cancel: 'Cancel',
  saveChanges: 'Save Changes',
  selectJiraIssues: 'Select Jira Issues',
  design: 'Design',
  development: 'Development',
  testing: 'Testing',
  bugFix: 'Bug Fix',
  documentation: 'Documentation',
  myPods: 'My Pods',
  postRetro: 'Post Retro',
  newRetro: 'New Retro',
  startDoing: 'Start Doing',
  stopDoing: 'Stop Doing',
  keepDoing: 'Keep Doing',
  viewRetros: 'View Retros',
  podRetroFeedback: 'Pod Retro Feedback',
  selectSprint: 'Select Sprint',
  thisTaskIsBlocker: 'This task is a blocker',
  category: 'Category',
  taskCreatedSuccessfully: 'Task created successfully!',
  taskManagement: 'Task Management',
  searchJiraIssues: 'Search JIRA issues...',
  creatingTask: 'Creating Task...',
  createTask: 'Create Task',
  description: 'Description',
  dueDate: 'Due date',
  commentsHistory: 'Comments History',
  noCommentsYet: 'No comments yet',
  writeAComment: 'Write a comment...',
  all: 'All',
  blockerStatus: 'Blocker Status',
  blockedTasks: 'Blocked Tasks',
  unblockedTasks: 'Unblocked Tasks',
  clearDateRange: 'Clear Date Range',
  selectDateRange: 'Select Date Range',
  showAllTime: 'Show All Time',
  noTasksFound: 'No tasks found',
  noLinkedIssues: 'No linked issues',
  timeSheet: 'Time Sheet',
  podTimeSheet: 'Pod TimeSheet',
  userStory: 'User Story',
  hours: 'Hours',
  minutes: 'Minutes',
  actions: 'Actions',
  submitTimeEntries: 'Submit Time Entries',
  selectCategory: 'Select Category',
  selectStory: 'Select Story',
  addRow: 'Add Row',
  podSelection: 'Pod Selection',
  selectPodToView: 'Select a pod to view sprint and Talent filters',
  toDo: 'To Do',
  podAssist: 'POD Assist',
  inProgress: 'In Progress',
  done: 'Done',
  selectPodsRequired: 'Select Pods (Required)',
  enterStoryDescription: 'Enter a Story Description',
  podSyncSummaries: 'POD Sync Summaries',
  enterMeetingUrl: 'Enter meeting URL...',
  searchInSummaries: 'Search in summaries...',
  dateAndTime: 'Date & Time',
  quickTimeRange: 'Quick Time Range',
   sortByDate: 'Sort by Date',
  selectTalents: 'Select Talents',
  filterBySpecificCandidates: 'Filter by specific candidates (optional)',
  talentSelection: 'Talent Selection',
  priority: 'Priority',
  addComment: 'Add Comment',
  taskDetails: 'Task Details',
  summary: 'Summary',
  addMeeting: 'Add Meeting',

  podAutomation: 'Pod Automation',
  uploading: 'Uploading...',
  uploadFile: 'Upload File',
  send: 'Send',
  submitting: 'Submitting...',
  enterYourQuestionHere: 'Enter your question here',
  submitTheResults: 'Submit the results',
  export: 'Export',
  podInsights: 'Pod Insights',
  askQuestionsAboutYourPod: 'Ask questions about your pod activities, team members, and more',
  welcomeToPodInsights: 'Welcome to POD Query!',
  startByAskingQuestionsLike: 'Start by asking questions like',
  showAllPodActivitiesThatHadBlockers: 'Show all pod activities that had blockers',
  listAllCandidatesAndTheirPods: 'List all candidates and their pods',
  getCountIsseswithNoCritria: 'Get count of issues with no acceptance criteria',
  askAnythingAboutYourPods: 'Ask anything about your pods, team members, activities...',
  sending: 'Sending...',
  analyzingYourQuestion: 'Analyzing your question...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Tickets',
  metricName: 'Metric Name',
  metricValue: 'Metric Value',
  commentsHistory: 'Comments History',
  noCommentsYet: 'No comments yet',
  writeAComment: 'Write a comment...',
  solutionManagement: 'Solution Management',
  searchSolutions: 'Search Solutions...',
  refresh: 'Refresh',
  createNewSolution: 'Create New Solution',
  solutionName: 'Solution Name',
  solutionDescription: 'Solution Description',
  updateSolution: 'Update Solution',
  createSolution: 'Create Solution',
  confirmSolutionDeletion: 'Are you sure you want to delete the Solution',
  artManagement: 'ART Management',
  podManagement: 'Pod Management',
  searchPods: 'Search pods...',
  viewPod: 'viewPod',
  searchARTs: 'Search ARTs...',
  noARTsFound: 'No ARTs found. Create your first ART by clicking the "Create New ART" button.',
  createNewART: 'Create New ART',
  selectGig: 'Select Gig',
  artName: 'ART Name',
  artDescription: 'ART Description',
  createART: 'Create ART',
  confirmDeletion: 'Confirm Deletion',
  confirmARTDeletion: 'Are you sure you want to delete the ART',
  primaryLanguage: 'Primary Language',
  selectSkills: 'Select Skills',
  timeZone: 'Time Zone',
  updateART: 'Update ART',
  somethingWentWrong: 'Something went wrong',
  reloadPage: 'Reload Page',
  privatePods: 'Private Pods',
  activePods: 'Active Pods',
  completedPods: 'Completed Pods',
  pendingPods: 'Pending Pods',
  loadingPods: 'Loading pods...',
  retry: 'Retry',
  noPodsFound: 'No pods found',
  createFirstPod: 'Create your first pod to get started',
  previous: 'Previous',
  showing: 'Showing',
  size: 'Size',
  teamSize: 'Team Size',
  activeMembers: 'Active Members',
  stakeholders: 'Stakeholders',
  podManagers: 'Pod Managers',
  addManager: 'Add Manager',
  podManager: 'Pod Manager',
  noManagersAssignedYet: 'No managers assigned yet',
  addManagersToHelpOversee: 'Add managers to help oversee this pod',
  noStakeholdersYet: 'No stakeholders yet',
  settings: 'Settings',
  deletePod: 'Delete Pod',
  addPodManager: 'Add Pod Manager',
  selectManagerToInvite: 'Select a manager to invite to this pod:',
  noManagersAvailableToInvite: 'No managers available to invite.',
  selectAManager: 'Select a manager',
  selectedManager: 'Selected Manager',
  inviteManager: 'Invite Manager',
  noTeamMembersYet: 'No team members yet',
  startByInvitingMembers: 'Start by inviting members to your pod',
  inviteTeamMembers: 'Invite Team Members',
  existingMembers: 'Existing Members',
  inviteByEmail: 'Invite by Email',
  searchByNameOrSkills: 'Search by name or skills...',
  optionalSelectUserToNotify: 'Optional: Select a user to notify via Slack',
  pleaseSelectPodToEnableFields: 'Please select a Pod to enable other fields',
  selectedCandidates: 'Selected Candidates',
  selectCandidatesToInvite: 'Select candidates to invite to this pod',
  availableCandidates: 'Available Candidates',
  inviteNewMembersByEmail: 'Invite New Members by Email',
  emailAddresses: 'Email Addresses',
  enterEmailAddresses: 'Enter email addresses (separated by commas)',
  hidePodTeamMembers: 'Hide this pod Team members in Find Pods section (Currently Visible)',
  technicalDetails: 'Technical Details',
  currentTeamSize: 'Current team size',
  communicationDetails: 'Communication Details',
  podReview: 'Pod Review',
  rating: 'Rating',
  writeReview: 'Write Review',
  shareYourExperience: 'Share your experience with this pod...',
  submitReview: 'Submit Review',
  viewPod: 'View Pod',
  managePod: 'Manage Pod',
  editPod: 'Edit Pod',
  skillsAndExperience: 'Skills & Experience',
  reviews: 'Reviews',
  documents: 'Documents',
  otherInfo: 'Other Info',
  noWorkExperienceDataAvailable: 'No work experience data available',
  selectART: 'Select ART',
  selectAnART: 'Select an ART',
  jiraConfiguration: 'Jira Configuration',
  jiraProjectKey: 'Jira Project Key',
  jiraURL: 'Jira URL',
  jiraAdminEmail: 'Jira Admin Email',
  jiraAdminAPIToken: 'Jira Admin API Token',
  jiraOpenStoryBugStatus: 'Jira Open Story/Bug Status',
  jiraClosedStoryBugStatus: 'Jira Closed Story/Bug Status',
  gitHubConfiguration: 'GitHub Configuration',
  gitHubUsername: 'GitHub Username',
  gitHubAPIToken: 'GitHub API Token',
  gitHubRepositoryName: 'GitHub Repository Name',
  circleCIConfiguration: 'CircleCI Configuration',
  circleCIGitHubUsername: 'CircleCI GitHub Username',
  circleCIGitHubRepository: 'CircleCI GitHub Repository',
  circleCIAPIToken: 'CircleCI API Token',
  sonarQubeConfiguration: 'SonarQube Configuration',
  sonarQubeCloudURL: 'SonarQube Cloud URL',
  sonarQubeAPIToken: 'SonarQube API Token',
  awsConfiguration: 'AWS Configuration',
  awsAccessKeyID: 'AWS Access Key ID',
  awsSecretAccessKey: 'AWS Secret Access Key',
  awsRegion: 'AWS Region',
  bitBucketConfiguration: 'BitBucket Configuration',
  bitBucketUsername: 'BitBucket Username',
  bitBucketAppPassword: 'BitBucket App Password',
  bitBucketWorkspace: 'BitBucket Workspace',
  openAIConfiguration: 'OpenAI Configuration',
  openAIToken: 'OpenAI Token',
  storyPointsCalculation: 'Story Points Calculation',
  uploadStoryPointsCalculationFile: 'Upload Story Points Calculation File',
  currentFile: 'Current file',
  notifications: 'Notifications',
  markAllAsRead: 'Mark all as read',
  tryAgain: 'Try Again',
  noNotificationsToDisplay: 'No notifications to display',
  viewAllNotifications: 'View All Notifications',
  enterMultipleEmailsSeparatedByCommas: 'Enter multiple emails separated by commas',
  addEmailAddressesToInvite: 'Add email addresses to invite new members',
  emailInvitationGuidelines: 'Email Invitation Guidelines',
  inviteesWillReceiveInstructions: 'Invitees will receive instructions to join this pod',
  theyWillNeedToCreateAccount: 'They will need to create an account if they don\'t have one already',
  noCandidatesAvailable: 'No candidates available',
  sendEmailInvites: 'Send Email Invites',

  processingDataAndGeneratingInsights: 'Processing data and generating insights',
  retroHistory: 'Retro History',
  filterByMember: 'Filter By Member',
  podProductivity: 'Pod Productivity',
  totalTasks: 'Total Tasks',
  completed: 'Completed',
  clearFilters: 'Clear Filters',
  totalActivities: 'Total Activities',
  pendingApproval: 'Pending Approval',
  sortBy: 'Sort By',
  editSolution: 'Edit Solution',
  cannotDeleteAssociatedWithARTs: 'Cannot delete - associated with ARTs',
  editART: 'Edit ART',
  createdDate: 'Created Date',
  podDetails: 'Pod Details',
  currentARTProject: 'Current ART/Project',
  artProject: 'ART/Project',
  selectAvailability: 'Select Availability',
  selectSkill: 'Select Skill',
  selectTimezone: 'Select Timezone',
  selectLocation: 'Select Location',
  selectBudget: 'Select Budget',
  podMember: 'Pod Member',
  addToPod: 'Add To Pod',
  talentDetails: 'Talent Details',
  reviewsFeedback: 'Reviews & Feedback',
  noEducationDataAvailable: 'No education data available',
  noCertificationDataAvailable: 'No certification data available',
  clientReview: 'Client Review',
  noReviewsAvailableYet: 'No reviews available yet',
  noClientReviews: 'This talent has not received any client reviews so far',
  resumeAvailable: 'Resume Available',
  viewDownloadResume: 'View or download the candidate\'s resume',
  noResumeAvailable: 'No Resume Available',
  noResumeUploaded: 'This talent has not uploaded a resume.',
  codingAssessment: 'Coding Assessment',
  assessmentAvailable: 'Assessment Available',
  viewAssessmentResults: 'View the candidate\'s coding assessment results',
  noAssessmentAvailable: 'No Assessment Available',
  noAssessmentCompleted: 'This talent has not completed a coding assessment.',
  partnerCompanyDetails: 'Partner Company Details',
  companyIntroductionVideo: 'Company Introduction Video',
  videoNotSupported: 'Your browser does not support the video tag.',
  location: 'Location',
  noPodsMatchingCriteria: 'No pods found matching your criteria',
  hirePod: 'Hire Pod',
  notificationHistory: 'Notification History',
  filter: 'Filter',
  allNotifications: 'All Notifications',
  markSelected: 'Mark Selected',
  unread: 'Unread',
  noNotificationsFound: 'No notifications found',
  searchNotifications: 'Search notifications...',
   subscriptionManagement: 'Subscription Management',
  choosePlanPrompt: 'Choose a plan that best fits your needs and scale as you grow',
  cancelSubscription: 'Cancel Subscription',
  choosePlan: 'Choose Plan',
  noPlansAvailable: 'No Plans Available',
  noPlansHelpText: 'Please check back later or contact support for assistance.',
  currentPlanDetails: 'Current Plan Details',
  renewalDate: 'Renewal Date',
  subscriptionId: 'Subscription ID',
  paymentMethod: 'Payment Method',
  cardHolder: 'Card Holder',
  expires: 'Expires',
  brand: 'Brand',
  billingHistory: 'Billing History',
  noInvoiceHistory: 'No invoice history available',
  needHelp: 'Need Help?',
  supportText: 'If you have any questions about our subscription plans or need assistance, our support team is here to help.',
  contactSupport: 'Contact Support',
  completeSubscription: 'Complete Your Subscription',
  planDetails: 'Plan Details',
  planName: 'Plan Name',
  basePrice: 'Base Price',
  numberOfUsers: 'Number of Users',
  billingCycle: 'Billing Cycle',
  orderSummary: 'Order Summary',
  annualDiscount: 'Annual Discount',
  billingPeriod: 'Billing Period',
  tax: 'Tax',
  totalWithTax: 'Total with Tax',
  annually: 'annually',
  continue: 'Continue',
  subscriptionSuccessful: 'Subscription Successful!',
  thankYouSubscribing: 'Thank you for subscribing to',
  subscriptionActivated: 'Your subscription has been successfully activated.',
  goToDashboard: 'Go to Dashboard',
  addPaymentMethod: 'Add Payment Method',
  cardNumber: 'Card Number',
  cardholderName: 'Cardholder Name',
  expiryMonth: 'Expiry Month',
  expiryYear: 'Expiry Year',
  postalCode: 'Postal Code',
  addCard: 'Add Card',
  paymentChoice: 'Use Existing Card or Add New Card',
  existingCardText: 'You already have an existing card ending in',
  useExistingCardPrompt: 'Would you like to use it for this subscription?',
  useExistingCard: 'Use Existing Card',
  addNewCard: 'Add New Card',
  processing: 'Processing...',
  subscriptionSuccessDetails: 'was successful!',
  accessAllFeatures: 'You can now access all features included in your subscription plan.',
  editCardDetails: 'Edit Card Details',
  managerInvite: 'Manager Invite',
  talentInvite: 'Talent Invite',
  invitePodManagers: 'Enter E-Mail to Invite Pod Managers',
  enterEmail: 'Enter E-Mail',
  invite: 'Invite',
  yourInvoices: 'Your Invoices',
  noInvoices: 'You don\'t have any invoices.',
  amountDue: 'Amount Due',
  amountPaid: 'Amount Paid',
 
  noActiveSubscriptionStart: 'You don\'t have an active subscription plan. Please click on',
subscribe: 'Subscribe', 
noActiveSubscriptionEnd: 'link to add a subscription.'
};
export default messagesEn;